import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-employee-services',
  templateUrl: './employee-services.component.html',
  styleUrls: ['./employee-services.component.scss']
})
export class EmployeeServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
